export const customerNavigationData = [
  {
    title: 'Home',
    key: 'dashboards',
    icon: 'fe fe-home',
    url: '/dashboard',
    count: 4,
  },
]
